import React from "react";

export default function SimpleOptionSelector({
  label,
  options,
  selectedClass,
  onChange,
  renderLabel,
  boxStyle = {},
  applyClass = true, // NEW PROP - default true
  advancedStylesNode = null
}) {
  const handleClick = (cls) => {
    onChange(cls === selectedClass ? "" : cls);
  };

  return (
    <div className="border_radius_medium border_full bg_light w_100" style={{ padding: 12 }}>
      <div className="d_flex justify_between align_center" style={{ marginBottom: 12 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 600,
            color: "#1f2937"
          }}
        >
          {label}
        </div>
        {advancedStylesNode && <div>{advancedStylesNode}</div>}
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 8,
          width: "100%"
        }}
      >
        {options.map((opt) => {
          const isSelected = selectedClass === opt.class;
          const appliedClass = applyClass ? opt.class : "";

          return (
            <div
              key={opt.class}
              onClick={() => handleClick(opt.class)}
              className={`simple_option ${appliedClass}`}
              title={opt.name}
              style={{
                boxSizing: "border-box",
                flex: 1,
                height: 46,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#111827",
                cursor: "pointer",
                border: "1px solid",
                borderColor: isSelected ? "#3b82f6" : "#e5e7eb",
                background: isSelected ? "#eff6ff" : "#ffffff",
                boxShadow: isSelected ? "0 0 0 1px rgba(59, 130, 246, 0.3)" : "none",
                transition: "all 0.2s ease-in-out",
                userSelect: "none",
                ...boxStyle
              }}
            >
              {renderLabel ? renderLabel(opt.class) : opt.name}
            </div>
          );
        })}
      </div>
    </div>
  );
}
